import React, { useState } from "react";
import styles from "./index.module.css";
import Overall from "./Overall";
import SingleItem from "./SingleItem";
import StockReport from "./StockReport";
import PanelHeader from "../components/PanelHeader";
import TabBar from "../components/TabBar";

const TABS = [
  { key: "overall", label: "Overall" },
  { key: "single", label: "By Product" },
  { key: "report", label: "Stock Report" },
];

export default function Statistics() {
  const [activeTab, setActiveTab] = useState("overall");

  return (
    <div className={styles.container}>
      <PanelHeader title="WWG Store - Statistics" />

      <TabBar tabs={TABS} activeKey={activeTab} onChange={setActiveTab} />

      <div className={styles.content}>
        <div className={styles.contentInner}>
          {activeTab === "overall" && <Overall />}
          {activeTab === "single" && <SingleItem />}
          {activeTab === "report" && <StockReport />}
        </div>
      </div>
    </div>
  );
}
